import audioBitrates from "../constants/audioBitrates";
import audioFormats from "../constants/audioFormats";
import contentTypes from "../constants/contentTypes";

import actionNames from "./actionNames";
import pendingFileRenameFunctions from "./ftp/constants/pendingFileRenameFunctions";
import metadataTemplateTypes from "./processors/metadata/constants/metadataTemplateTypes";
import protocols from "./protocols";
import authTypes from "./sendToApi/authTypes";

const actionArgs = {
	[actionNames.RECODE_AUDIO]: [
		{
			id: "AUDIO_FORMAT",
			required: true,
			options: [audioFormats.WAV, audioFormats.MP3],
		},
		{
			id: "AUDIO_BITRATE",
			type: "number",
			options: Object.values(audioBitrates),
			display: (args) => args.AUDIO_FORMAT === audioFormats.MP3,
		},
	],
	[actionNames.RENAME_FILE]: [
		{
			id: "FOLDER_PATTERN",
			type: "string",
		},
		{
			id: "FILE_PATTERN",
			type: "string",
		},
	],
	[actionNames.GENERATE_METADATA]: [
		{
			id: "METADATA_FORMAT",
			options: [
				metadataTemplateTypes.ONIX,
				metadataTemplateTypes.EXCEL,
				metadataTemplateTypes.CUSTOM_XML,
				metadataTemplateTypes.JSON,
			],
		},
	],
	[actionNames.SAVE_PUBLIC_URLS]: [
		{
			id: "BUCKET",
			type: "string",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
	],

	[actionNames.SAVE_TO_BUCKET]: [
		{
			id: "BUCKET",
			type: "string",
		},
		{
			id: "PATH",
			type: "string",
		},
		{
			id: "SAVE_EXPORT_ZIP",
			type: "boolean",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
	],
	[actionNames.SEND_TO_FTP]: [
		{
			id: "HOST",
			type: "string",
		},
		{
			id: "PORT",
			type: "string",
		},
		{
			id: "USER",
			type: "string",
		},
		{
			id: "PASSWORD",
			type: "password",
		},
		{
			id: "SECURE",
			type: "boolean",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
	],
	[actionNames.SEND_TO_SFTP]: [
		{
			id: "HOST",
			type: "string",
		},
		{
			id: "PORT",
			type: "string",
		},
		{
			id: "USER",
			type: "string",
		},
		{
			id: "PASSWORD",
			type: "password",
		},
		{
			id: "PRIVATE_KEY",
			type: "string",
		},
		{
			id: "USE_PENDING_FILE_NAME",
			type: "boolean",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
		{
			id: "OVERRIDE_PATH",
			type: "string",
		},
	],
	[actionNames.LFTP_SEND]: [
		{
			id: "HOST",
			type: "string",
		},
		{
			id: "PROTOCOL",
			options: [protocols.FTP, protocols.SFTP],
		},
		{
			id: "PORT",
			type: "string",
		},
		{
			id: "USER",
			type: "string",
		},
		{
			id: "PASSWORD",
			type: "password",
		},
		{
			id: "PRIVATE_KEY",
			type: "string",
		},
		{
			id: "USE_PENDING_FILE_NAME",
			type: "boolean",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
		{
			id: "OVERRIDE_PATH",
			type: "string",
		},
	],
	[actionNames.SSH2_SFTP]: [
		{
			id: "HOST",
			type: "string",
		},
		{
			id: "PORT",
			type: "string",
		},
		{
			id: "USER",
			type: "string",
		},
		{
			id: "PASSWORD",
			type: "password",
		},
		{
			id: "PRIVATE_KEY",
			type: "string",
		},
		{
			id: "PENDING_FILE_NAME_RENAME_FN",
			required: true,
			options: [
				pendingFileRenameFunctions.NONE,
				pendingFileRenameFunctions.RENAME,
				pendingFileRenameFunctions.POSIX_RENAME,
			],
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
		{
			id: "OVERRIDE_PATH",
			type: "string",
		},
	],
	[actionNames.BASIC_FTP]: [
		{
			id: "HOST",
			type: "string",
		},
		{
			id: "PORT",
			type: "string",
		},
		{
			id: "USER",
			type: "string",
		},
		{
			id: "PASSWORD",
			type: "password",
		},
		{
			id: "SECURE",
			type: "boolean",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
	],
	[actionNames.SEND_TO_API]: [
		{
			id: "AUTH_TYPE",
			required: true,
			options: [authTypes.OAUTH, authTypes.NONE],
		},
		{
			id: "API_URL",
			type: "string",
		},
		{
			id: "AUTH_URL",
			type: "string",
		},
		{
			id: "USER",
			type: "string",
		},
		{
			id: "PASSWORD",
			type: "password",
		},
		{
			id: "EXTRA_AUTH_BODY_PARAMS",
			type: "string",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
	],
	[actionNames.SEND_TO_S3]: [
		{
			id: "ACCESS_KEY_ID",
			type: "string",
		},
		{
			id: "SECRET_ACCESS_KEY",
			type: "password",
		},
		{
			id: "BUCKET_REGION",
			type: "string",
		},
		{
			id: "BUCKET_NAME",
			type: "string",
		},
		{
			id: "BUCKET_PATH",
			type: "string",
		},
		{
			id: "LANGUAGE_BASED_BUCKET_PATHS",
			type: "string",
		},
		{
			id: "CONCURRENT_UPLOADS",
			type: "number",
		},
	],
	[actionNames.RESIZE_IMAGE]: [
		{
			id: "MIN_WIDTH",
			type: "number",
		},
		{
			id: "MAX_WIDTH",
			type: "number",
		},
		{
			id: "MIN_HEIGHT",
			type: "number",
		},
		{
			id: "MAX_HEIGHT",
			type: "number",
		},
	],
	[actionNames.COMPRESS_IMAGE]: [
		{
			id: "MAX_SIZE_IN_BYTES",
			type: "number",
			required: true,
		},
	],
	[actionNames.ZIP_FILES]: [
		{
			id: "MAX_PART_SIZE_BYTES",
			type: "number",
		},
		{
			id: "ZIP_FOLDER_PATTERN",
			type: "string",
		},
		{
			id: "ZIP_RENAME_PATTERN",
			type: "string",
		},
		{
			id: "ZIP_PART_RENAME_PATTERN",
			type: "string",
		},
	],
	[actionNames.SEND_EMAIL]: [
		{
			id: "SEND_FROM",
			type: "string",
			required: true,
		},
		{
			id: "SEND_TO",
			type: "string",
			required: true,
		},
		{
			id: "CC_TO",
			type: "string",
		},
		{
			id: "BCC_TO",
			type: "string",
		},
		{
			id: "SUBJECT",
			type: "string",
			required: true,
		},
		{
			id: "MESSAGE_TEMPLATE",
			type: "textarea",
			required: true,
		},
	],
	[actionNames.GENERATE_FILE]: [
		{
			id: "FILE_NAME",
			type: "string",
			required: true,
		},
		{
			id: "CONTENT_TYPE",
			type: "string",
			options: Object.values(contentTypes),
			required: true,
		},
		{
			id: "FOLDER_PATTERN",
			type: "string",
			required: false,
		},
		{
			id: "FILE_CONTENT_TEMPLATE",
			type: "string",
			required: false,
		},
	],
	[actionNames.DELAY]: [
		{
			id: "DURATION_MS",
			type: "number",
		},
	],
};

export default actionArgs;
